export default {
    CaptchaAppId: '2097565944'
}